/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const companyQueryOptions = (queryParams) =>
  queryOptions({
    queryKey: queryKeys.company.all,
    queryFn: () => fetcher({ method: "GET", url: "/public/company" }),
    staleTime: Infinity,
    ...queryParams,
  });

export const useCompany = (queryParams) => useQuery(companyQueryOptions(queryParams));
export const useSuspenseCompany = (queryParams) => useSuspenseQuery(companyQueryOptions(queryParams));
